import React from "react";
import Logo from "../../../assets/img/Logo.svg";
import Vezarat from "../../../assets/img/amoozesh-logo.png";
import flag from "../../../assets/img/FLAG-IRAN.png";
import leader from "../../../assets/img/leader.png";
import { Box, Flex, Button } from "@chakra-ui/react";
function Header({ headerClass, textClass }: any) {
  return (
    <Flex direction="row-reverse" justifyContent="space-evenly" className="header">
      <div>
        <img src={flag} className="flag-header" />
      </div>

      <Flex
        direction="column"
        alignItems="center"
        justifyContent="center"
        className="header-landing"
        mb="80px"
        mt={{ xl: "60px", lg: "60px", md: "55px", sm: "40px" }}
      >
        <img
          src={Logo}
          //className="header-logo"
          className={headerClass}
        />
        <img
          src={Vezarat}
          //className="logo-text"
          className={textClass}
        />
      </Flex>
      <div><img src={leader} className="leader-header" /></div>
    </Flex>
  );
}

export default Header;
